import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import style from './NavBar.module.css'

export default function NavBar() {
    const location = useLocation();

    return (
        <div className={`z-50 absolute top-0 right-0 bg-[#E9F2FB] rounded-bl-3xl flex flex-col gap-3 px-5 py-4 ${style.shadowBlockCorner}`}>
            {["about", "resume", "projects", "contacts"].map((item) => (
                <NavLink
                    key={item}
                    to={`/${item === "about" ? "" : item}`}
                    className={({ isActive }) =>
                        `font-medium ${isActive ? "text-[#0369E4]" : "text-[#19284D]"}`
                    }
                >
                    {item.charAt(0).toUpperCase() + item.slice(1)}
                    {(location.pathname === `/${item}` || (location.pathname === '/' && item === "about")) 
                        && <span className='block bg-[#0369E4] h-[0.1rem] w-[50%]'></span>}
                </NavLink>
            ))}
        </div>
    )
}
